/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

//==============================================================
// START Enums and Input Objects
//==============================================================

export enum AccessLevelEnum {
  CREHANA_CORE = 'CREHANA_CORE',
  CREHANA_CORE_ELEVATE = 'CREHANA_CORE_ELEVATE',
  CREHANA_ELEVATE = 'CREHANA_ELEVATE',
}

export enum ApprovalRequirementEnum {
  FINAL_PROJECT = 'FINAL_PROJECT',
  NOT_REQUIREMENT = 'NOT_REQUIREMENT',
  QUIZ_EVALUATION = 'QUIZ_EVALUATION',
}

export enum CourseTypeEnum {
  COURSE_TYPE_B2B = 'COURSE_TYPE_B2B',
  COURSE_TYPE_B2B_CLASSROOMS = 'COURSE_TYPE_B2B_CLASSROOMS',
  COURSE_TYPE_DEGREE = 'COURSE_TYPE_DEGREE',
  COURSE_TYPE_FREE = 'COURSE_TYPE_FREE',
  COURSE_TYPE_MEMBERSHIP = 'COURSE_TYPE_MEMBERSHIP',
  COURSE_TYPE_PAID = 'COURSE_TYPE_PAID',
  COURSE_TYPE_ROCKSTAR = 'COURSE_TYPE_ROCKSTAR',
  COURSE_TYPE_TEMPORAL_ACCESS = 'COURSE_TYPE_TEMPORAL_ACCESS',
}

export enum CourseVideoTrailerSourceVideoSourceType {
  HLSV3 = 'HLSV3',
  HLSV4 = 'HLSV4',
  MP3 = 'MP3',
  MP4 = 'MP4',
  NONE = 'NONE',
}

export enum DegreeSyllabusStatusEnum {
  STATUS_CLOSURE = 'STATUS_CLOSURE',
  STATUS_FINISHED = 'STATUS_FINISHED',
  STATUS_ONBOARDING = 'STATUS_ONBOARDING',
  STATUS_PROGRESS = 'STATUS_PROGRESS',
  STATUS_SALE = 'STATUS_SALE',
}

export enum EnrollmentTypeEnum {
  ENROLLMENT_B2B = 'ENROLLMENT_B2B',
  ENROLLMENT_DEGREE = 'ENROLLMENT_DEGREE',
  ENROLLMENT_FREE = 'ENROLLMENT_FREE',
  ENROLLMENT_FREEMIUM = 'ENROLLMENT_FREEMIUM',
  ENROLLMENT_FREE_MEMBERSHIP = 'ENROLLMENT_FREE_MEMBERSHIP',
  ENROLLMENT_GITCARD = 'ENROLLMENT_GITCARD',
  ENROLLMENT_MEMBERSHIP = 'ENROLLMENT_MEMBERSHIP',
  ENROLLMENT_MENTOR = 'ENROLLMENT_MENTOR',
  ENROLLMENT_PAID = 'ENROLLMENT_PAID',
  ENROLLMENT_PREVIEW_TRIAL = 'ENROLLMENT_PREVIEW_TRIAL',
  ENROLLMENT_PROFESSOR = 'ENROLLMENT_PROFESSOR',
  ENROLLMENT_STAFF = 'ENROLLMENT_STAFF',
  ENROLLMENT_TEMPORAL_ACCESS = 'ENROLLMENT_TEMPORAL_ACCESS',
}

export enum QuizTypeEnum {
  TYPE_CUMULATIVE = 'TYPE_CUMULATIVE',
  TYPE_FORMATIVE = 'TYPE_FORMATIVE',
}

export enum StatusProjectEnum {
  CERTIFIED = 'CERTIFIED',
  DRAFT = 'DRAFT',
  FINISHED = 'FINISHED',
  OBSERVED = 'OBSERVED',
  PUBLISHED = 'PUBLISHED',
}

export interface AddCourseUserInput {
  userId: string;
  courseId: string;
  clientMutationId?: string | null;
}

export interface ArticlesTrackNode {
  id?: number | null;
  order?: number | null;
}

export interface CoursesTrackNode {
  id?: number | null;
  order?: number | null;
}

export interface DeleteOrganizationInput {
  slug?: string | null;
  clientMutationId?: string | null;
}

export interface IntegrationsTrackNode {
  integrationItemId?: number | null;
  integrationObjectId?: string | null;
  order?: number | null;
}

export interface OrganizationCourseCreateInput {
  title: string;
  levelId: number;
  description?: string | null;
}

export interface UpdateUserOrganizationInput {
  organizationSlug?: string | null;
  userId: number;
  role?: string | null;
  isActive?: boolean | null;
  departament?: string | null;
  subDepartament?: string | null;
  status?: number | null;
  clientMutationId?: string | null;
}

//==============================================================
// END Enums and Input Objects
//==============================================================
